import React, { useState } from "react";
import { useSidebar } from "@/components/ui/sidebar";

export function useSidebarParentMenu(initiallyExpanded: boolean) {
  const { state, isMobile, setOpen } = useSidebar();
  const [isExpanded, setIsExpanded] = useState(initiallyExpanded);

  const expandFromIcon = (event: React.MouseEvent) => {
    if (state !== "collapsed" || isMobile) {
      return;
    }
    event.preventDefault();
    setOpen(true);
    setIsExpanded(true);
  };

  return { isExpanded, setIsExpanded, expandFromIcon };
}
